import { makeStyles } from '@material-ui/core';

export const usePersonInfoStyles = makeStyles(theme => ({
  container: {
    marginBottom: '20px',
  },
  avatar: {
    height: theme.spacing(18),
    width: theme.spacing(15),
    marginBottom: theme.spacing(3),
  },
  fullName: {
    marginTop: theme.spacing(1),
    fontWeight: 'bold',
    minHeight: '33px',
  },
}));
